import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import HeaderNav from "@/components/HeaderNav";
import HeroSection from "@/components/HeroSection";
import EditorialMarquee from "@/components/EditorialMarquee";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import PortfolioSection from "@/components/PortfolioSection";
import ReviewsSection from "@/components/ReviewsSection";
import PartnersMarquee from "@/components/PartnersMarquee";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-paper text-ink">
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#0D0E11", color: "#FAFAF8", border: "1px solid #2a2c31" } }} />
      <HeaderNav />
      <main>
        <HeroSection />
        <EditorialMarquee />
        <AboutSection />
        <ServicesSection />
        <PortfolioSection />
        <ReviewsSection />
        <PartnersMarquee />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
